export const categoryFormatter = (category: string[]) => {
  return category ? category.filter((x) => !!x).join(".") : "";
};
